import React, { useMemo } from 'react';
import styled from 'styled-components';

import Google from '../../../images/logo-google.inline.svg';
import { PartnerType } from '../SchoolReviewForm/SchoolRefReviewForm/constants/enums';
import { LINKS_COLOR } from '../../../theme';

const Container = styled.div`
  margin: 16px 0;
`;

const GoogleLink = styled.a`
  display: inline-flex;
  align-items: center;
  margin-top: 16px;
  height: 48px;
  padding: 0 10px;
  font-size: 16px;
  border-radius: 4px;
  font-weight: bold;
  line-height: 1.5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  background-color: ${(props) => props.theme.colors?.buttonColor || props.theme.buttonColor
    ? (props.theme.colors?.buttonColor || props.theme.buttonColor)
    : LINKS_COLOR
};
  border: none;
  color: #fff;

  &:hover,
  &:focus {
    color: #fff;
    text-decoration: none;
  }
`;

const GoogleIcon = styled(Google)`
  width: 32px;
  height: 32px;
  margin-right: 8px;
`;

const ShareReviewMessage = ({ reviewId, isExamCenter, partnerName }: { reviewId: string, isExamCenter?: boolean, partnerName?: string }) => {
  const shareOnGooglePath = useMemo(() => {
    if (isExamCenter) {
      return `/avis-centre-examen/${reviewId}/partager`;
    }

    let href = `/avis/${reviewId}/partager`;
    if (partnerName && partnerName === PartnerType.AvisSolution) {
      href += '?partner=avis-solution';
    }

    return href;
  }, []);

  return (
    <Container>
      <div>
        Partagez votre avis sur Google en 3 clics
        (sans&nbsp;exagérer)&nbsp;!
      </div>

      <GoogleLink
        href={shareOnGooglePath}
        target="_blank"
        rel="noopener noreferrer"
      >
        <GoogleIcon />
        Poster mon avis sur Google
      </GoogleLink>
    </Container>
  );
};

ShareReviewMessage.defaultProps = {
  isExamCenter: false,
  partnerName: '',
};

export { ShareReviewMessage };
